import type { PortalAccount } from "../../store/portalAuthApi";

export type AccountLinkResult = { previousIds: string[]; accounts: PortalAccount[] | null };

export const linkedAccountsView = {
  create(verifiedEmails: string[], accounts: PortalAccount[], result: AccountLinkResult | null) {
    return {
      emailGroups: verifiedEmails.map((address) => ({
        address,
        accounts: accounts.filter((account) =>
          account.matchedEmails?.some((email) => email.toLowerCase() === address.toLowerCase()),
        ),
      })),
      newAccounts: result?.accounts?.filter(
        (account) => !result.previousIds.includes(account.customerId),
      ),
    };
  },
};
